/*
import {
  breakpoints,
  colors,
  measurements
} from '../../settings/settings';
*/


import {
  animatedLogo
} from '../../modules/animatedlogos/logo-helpers';

export function animatedLogosInit(container, location) {

  console.log("animatedLogosInit()", container, location);

  if (location == "single-projects") {

    var animatedlogoType = "arc",

      animatedlogoTypeObject = container.querySelector('.animated-logo#arc_logo');

    animatedLogo(animatedlogoType, animatedlogoTypeObject)

    var animatedlogoType = "cc",
      animatedlogoTypeObject = container.querySelector('.animated-logo#cc_logo');

    animatedLogo(animatedlogoType, animatedlogoTypeObject)


  } else if (location == "job-listing-item") {
    console.log("job-listing-item",location, container);

    var animatedlogoTypeObjectArc = container.querySelector('.animated-logo#arc_logo');
    if (animatedlogoTypeObjectArc) {
      var animatedlogoType = "arc";
      animatedLogo(animatedlogoType, animatedlogoTypeObjectArc)
    }

    var animatedlogoTypeObjectCc = container.querySelector('.animated-logo#cc_logo');

    if (animatedlogoTypeObjectCc) {
      var animatedlogoType = "cc";
      animatedLogo(animatedlogoType, animatedlogoTypeObjectCc)
    }

  } else if (location == "approach-page") {

    var animatedlogoType = "arc",
      animatedlogoTypeObject = container.querySelector('.animated-logo#arc_logo');

    animatedLogo(animatedlogoType, animatedlogoTypeObject)

    var animatedlogoType = "cc",
      animatedlogoTypeObject = container.querySelector('.animated-logo#cc_logo');

    animatedLogo(animatedlogoType, animatedlogoTypeObject)
  } else if (location == "about-page") {


    var animatedlogoType = "arc",
      animatedlogoTypeObject = container.querySelector('.animated-logo#arc_logo');

    animatedLogo(animatedlogoType, animatedlogoTypeObject)

    var animatedlogoType = "cc",
      animatedlogoTypeObject = container.querySelector('.animated-logo#cc_logo');

    animatedLogo(animatedlogoType, animatedlogoTypeObject)
  }

} //export default function init()